import type { FC } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import Badge from '@segment/matcha/components/Badge'

import CardBase, * as CardUseCase from '@segment/matcha/recipes/Card'

import type { UseCase } from '@segment/api/routes/useCases/types'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

export interface CardProps {
  useCase?: UseCase[`useCase`]
  title: UseCase[`title`]
  description: UseCase[`description`]
  url: UseCase[`url`]
}
const Card: FC<CardProps> = ({ title, description, url, useCase }) => {
  const pageConfig = usePageConfig()
  return (
    <CardBase href={getAbsoluteUrl(`/use-cases/${url}`, pageConfig)}>
      <CardUseCase.Body>
        <CardUseCase.Accessories>
          <CardUseCase.AccessoriesRow>
            {useCase?.map((use, key) => (
              <Badge key={key} variant="outlined">
                {use}
              </Badge>
            ))}
          </CardUseCase.AccessoriesRow>
        </CardUseCase.Accessories>
        <CardUseCase.Copy>
          <CardUseCase.Headline tag="h2">{title}</CardUseCase.Headline>
          <CardUseCase.Description>{description}</CardUseCase.Description>
        </CardUseCase.Copy>
        <CardUseCase.Action alignment="left">
          <ButtonText iconEnd={ChevronRightIcon}>See available recipes</ButtonText>
        </CardUseCase.Action>
      </CardUseCase.Body>
    </CardBase>
  )
}

export default Card
